export class PrintTemplateSetup {
    Id?: number;
    HeaderMargin: number;
    FootarMargin: number;
    ImageWidth: number;
    HeaderImage: boolean = false;

}
